export default {

    init: function () {
        if ($('.asset-feed').length < 1) return;
        this.bindEvents();
    },

    showMoreAssets: function ($$) {
        let additionalAssetsContainer = $('.show-more-assets'),
            showMoreButtonContainer = $('.show-more-button-container');
        additionalAssetsContainer.removeClass('display-none');
        showMoreButtonContainer.addClass('display-none');
    },

    bindEvents: function () {
        let _this = this;
        $('.show-more-assets').on('click', function () {
            _this.showMoreAssets(this);
            $('html, body').animate({
                scrollTop: $('.asset-feed .show-more-assets').offset().top - 100,
            }, 1000, function () {
            });
        });
    },
};
